/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelZoneArea.ts                      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/zone-area";

export class AutogenModelZoneArea<RowType extends ModelRow> extends Endpoint<RowType, RowZoneAreaFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowZoneArea extends ModelRow<RowZoneAreaFields> {
	constructor(values?: Partial<RowZoneAreaFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowZoneAreaFields {
	company_id: string;
	descr: string;
	id: string;
	zone_region_id: string;
}

